import { GivelifyLabel, GivelifyModal } from '@givelify/givelify-ui';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

interface StyledButtonProps {
    $isError?: boolean;
}

export const StyledModal = styled(GivelifyModal)(({ theme }) => ({
    '& .confirmation-modal': {
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    '& .confirmation-modal-body': {
        minHeight: 560,
        marginTop: 30,
    },
    '& .modal-header': {
        minHeight: 45,
    },
}));

export const ModalContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'left',
    alignItems: 'left',
    paddingLeft: 40,
    paddingRight: 40,
    [theme.breakpoints.down('sm')]: {
        paddingLeft: 16,
        paddingRight: 16,
    },
}));

export const Statement = styled(GivelifyLabel)({
    textAlign: 'left',
});

export const Description = styled(GivelifyLabel)({
    fontSize: 16,
    lineHeight: '24px',
});

export const ErrorBanner = styled('div')({
    paddingTop: 3,
    paddingBottom: 3,
    lineHeight: '18px',
});

export const ModalFooter = styled('div')({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 32,
    marginBottom: 32,
});

export const StyledButton = styled(Button, {
    shouldForwardProp: (prop) => prop !== '$isError',
})<StyledButtonProps>(({ theme, $isError }) => ({
    [theme.breakpoints.down('sm')]: {
        minWidth: 140,
        height: '40px',
    },
    ...(($isError && {
        background: theme.palette.error.main,
        color: theme.palette.error.contrastText,
        '&:hover': {
            background: theme.palette.error.dark,
        },
        '&:disabled': {
            background: theme.legacy.colors.neutralPlatinum,
        },
    }) || {
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        '&:hover': {
            background: theme.palette.primary.dark,
        },
        '&:disabled': {
            background: theme.legacy.colors.neutralPlatinum,
        },
    }),
}));

export const UserAvatarWrapper = styled('div')({
    width: 48,
    margin: '16px 8px 16px 0px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

export const UsernameContainer = styled('div')({
    width: '100%',
    display: 'flex',
    cursor: 'pointer',
    marginBottom: '10px',
    marginTop: '10px',
});

export const FullName = styled('div')({
    lineHeight: '22px',
    textOverflow: 'ellipsis',
    fontSize: 17,
});

export const Title = styled(GivelifyLabel)(({ theme }) => ({
    lineHeight: '14px',
    color: theme.legacy.colors.neutralGrey,
}));

export const UserNameContent = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginRight: 'auto',
    maxWidth: 'calc(100% - 176px)',
    '@media (max-width: 360px)': {
        maxWidth: 'unset',
    },
});

export const YouLabel = styled('span')(({ theme }) => ({
    color: theme.legacy.colors.neutralGrey75,
    lineHeight: 'inherit',
}));

export const ChangeAccountOwnerNameWrapper = styled('div')({
    display: 'inline-flex',
});
